var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards-content-background"},[_c('Titles',{attrs:{"type":1,"text":'Associe-se'}}),_c('div',{staticClass:"cards-box-content"},_vm._l((_vm.cards),function(card){return _c('Card',{key:card.id,staticStyle:{"margin-bottom":"4vw"},attrs:{"card":card}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }